import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class IeHeaderInterceptor implements HttpInterceptor {
	// Urls for which extra IE headers are disabled.
	excludedUrls: string[] = ['serverprovider.asamco.com', 'b2clogin.com', 'assets/'];

	constructor() {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (
			// Is not excluded url.
			this.excludedUrls.every(function (url) {
				return !request.url.includes(url);
			}) &&
			// Is IE.
			window.navigator.userAgent.indexOf('Trident') > -1
		) {
			request = request.clone({
				headers: request.headers.set('Cache-Control', 'no-cache').set('Pragma', 'no-cache'),
			});
		}
		return next.handle(request);
	}
}
